import { AlpineData } from '@/js/interfaces/Components/alpinejs/BpuUpdate/BpuUpdateScroll';
import { createAlpineComponent } from '@nolikein/typed-alpinejs';

export default {
    name: 'BpuUpdateScroll',
    component: () => createAlpineComponent<AlpineData>({
        display: false,
        scrollToBottom: () =>
            scroll({ top: document.documentElement.scrollHeight, behavior: 'smooth' }),
        onDocumentTreated() {
            this.display = true;
        },
        onBpuUpdating() {
            this.display = false;
        },
    }),
};
